module.exports = __webpack_public_path__ + "img/result-detail-invest-outleft01.e3ab060c.svg";